import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import DbInput from "../DB-Components/DbInput.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderLicensePlateInput',
  props: {
  modelValue: {
    type: String,
    default: null,
  },
  ariainvalid: {
    type: String as () => "false" | "grammar" | "spelling" | "true" | undefined,
    default: "false",
    required: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: null,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const inputValue = ref(props.modelValue);
const emit = __emit;

const formattedInputValue = computed(() => {
  let formattedString = inputValue.value == null ? "" : inputValue.value;
  if (formattedString) {
    const leadingIgnoredCharactersStripped = formattedString.replace(
      /^[,/\\\s-]+/,
      ""
    );
    const endingIgnoredCharactersStripped =
      leadingIgnoredCharactersStripped.replace(/^[,/\\\s-]+/, "");
    formattedString = endingIgnoredCharactersStripped;
  }
  return formattedString;
});

const handleInput = (event: HTMLInputElement) => {
  const target = event.target as HTMLInputElement;
  const licenseNumber = target.value.toUpperCase();
  emit("update:modelValue", licenseNumber);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DbInput, {
    modelValue: formattedInputValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formattedInputValue).value = $event)),
    value: formattedInputValue.value,
    onInput: handleInput,
    ariainvalid: __props.ariainvalid,
    class: "w-full hydrated",
    placeholder: __props.placeholder,
    disabled: __props.disabled
  }, null, 8, ["modelValue", "value", "ariainvalid", "placeholder", "disabled"]))
}
}

})